function initPhotoSwipe() {
	var self = this;
	this.classNameCSS = '.gallery-ps';
	if ($(this.classNameCSS).length)
		this.init(this.classNameCSS);
}

initPhotoSwipe.prototype.getItems = function() {
	var self = this,
		el = $(this.classNameCSS),
		items = [];

	if ($(this.classNameCSS).length) {
		$.each(el, function(i, gallery) {
			var item,
				dataSize = el.attr('data-size') ? el.attr('data-size') : "1920x1080",
				title = el.attr('data-title') ? el.attr('data-title') : "",
				size = dataSize.split('x'),
				childElements,
				thumbnailEl,
				gid = i;

			$(gallery).attr('data-gid',gid);

			items.push([]);

			$.each($(gallery).find("a.item-ps"),function(i,v) {
				if (!$(v).closest('.slick-slide').hasClass('slick-cloned')) {
					var src = $(v).attr("href");
					var msrc = $(v).attr('data-msrc');
					$(v).attr('data-pid',i);
					if ($(v).attr('data-size') !== undefined) {
						mySize = $(v).attr('data-size').split('x');
					}
					else {
						mySize = size;
					}
					item = {
						src: src,
						msrc: msrc,
						el: $(v).find('div')[0],
						w: parseInt(mySize[0], 10),
						h: parseInt(mySize[1], 10),
						title: $(v).attr('data-title'),
						description: $(v).attr('data-description'),
					};
					var mediumSrc = $(v).attr('data-med');
		          	if(mediumSrc) {
		            	var medSize = $(v).attr('data-med-size').split('x');
		            	// "medium-sized" image
		            	item.m = {
		              		src: mediumSrc,
		              		w: parseInt(medSize[0], 10),
		              		h: parseInt(medSize[1], 10)
		            	};
		          	}
					// original image
		          	item.o = {
		          		src: item.src,
		          		w: item.w,
		          		h: item.h
		          	};
					items[gid].push(item);
				}
			});
		});
	}
	this.items = items;
};

initPhotoSwipe.prototype.init = function(gallerySelector) {

	var self = this;
	pswpElement ='';
	var markup = '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">';
	markup += '<div class="pswp__bg"></div>';
	markup += '<div class="pswp__scroll-wrap">';
	markup += '<div class="pswp__container">';
	markup += '<div class="pswp__item"></div>';
	markup += '<div class="pswp__item"></div>';
	markup += '<div class="pswp__item"></div>';
	markup += '</div>';
	markup += '<div class="pswp__ui pswp__ui--hidden">';
	markup += '<div class="pswp__top-bar">';
	markup += '<div class="nav-buttons">';
	markup += '<span class="gallery-nav__icon close"><span class="font-icon -close pswp__button--close"></span></span>';
	markup += '<span class="gallery-nav__icon share"><span class="font-icon -share pswp__button--share"></span></span>';
	markup += '<span class="gallery-nav__icon fullscreen"><span class="font-icon -full_screen pswp__button--fs"></span></span>';
	markup += '<span class="gallery-nav__icon zoom"><span class="zoom-icon pswp__button--zoom zoom-in"></span></span>';
	markup += '</div>';
	markup += '<span class="gallery-nav__icon pswp__counter"><div class="pswp__counter"></div></span>';
	markup += '<div class="pswp__preloader">';
	markup += '<div class="pswp__preloader__icn">';
	markup += '<div class="pswp__preloader__cut">';
	markup += '<div class="pswp__preloader__donut"></div>';
	markup += '</div>';
	markup += '</div>';
	markup += '</div>';
	markup += '</div>';
	markup += '<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">';
	markup += '<div class="pswp__share-tooltip"></div>';
	markup += '</div>';
	markup += '<div class="font-icon -arr_lft_alt pswp__arrow pswp__arrow--left"><div></div></div>';
	markup += '<div class="font-icon -arr_rgt_alt pswp__arrow pswp__arrow--right"><div></div></div>';
	markup += '<div class="pswp__ ">';
	markup += '<div class="pswp__caption__center"></div>';
	markup += '</div>';
	markup += '</div>';
	markup += '<div class="pswp__info main">';
	markup += '<div class="info-icon"><p><span></span></p></div>';
	markup += '<div class="title-text">';
	markup += '<p class="title"></p>';
	markup += '<div class="customCounter" id="counterCustom"></div>';
	markup += '</div>';
	markup += '</div>';
	markup += '</div>';
	markup += '</div>';

	$('.pswp').remove();
	$('body').append(markup);
	pswpElement = document.querySelectorAll('.pswp')[0];
	self.getItems();

	// find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;

        var eTarget = e.target || e.srcElement;

        if ($(eTarget).closest('a').hasClass('item-ps') || $(eTarget).hasClass('item-ps')) {
        	e.preventDefault();
	        // find root element of slide
	    	var clickedListItem = closest(eTarget, function(el) {
	        	return (el.tagName === 'A');
	        });

	        if(!clickedListItem) {
	            return;
	        }

	        // find index of clicked item by looping through all child nodes
	        // alternatively, you may define index via data- attribute
        	var clickedGallery = $(clickedListItem).closest('.gallery-ps'),
            childNodes = $(clickedListItem).closest('.gallery-ps').find('a.item-ps'),
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;
	        for (var i = 0; i < numChildNodes; i++) {
	            if(childNodes[i].nodeType !== 1) { 
	                continue; 
	            }

	            if(childNodes[i] === clickedListItem) {
	                index = nodeIndex;
	                break;
	            }
	            nodeIndex++;
	        }

	        if(index >= 0) {
	        	// open PhotoSwipe if valid index found
	            // openPhotoSwipe(pswpElement, false, index, clickedGallery); 
	            // podanie clickedGallery powoduje buga - zdjecia sie nie laduja przy cofaniu strzalkami w otwartej galerii
	            openPhotoSwipe(eTarget, index);
	        }
	        return false;
	    }
    };

    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };
	
	var openPhotoSwipe = function (target, index, galleryEl, fromURL, init) {
		var startIndex, newIndexPs, indexPs, textWidth,
			gallery = $(target).closest('.gallery-ps'),
			slickSlider = $(target).closest('.slick-slider');

		if (galleryEl)
			gallery = galleryEl;
		if (!target || init) {
			startIndex = index - 1;
		} else {
			startIndex = $(target).closest("a.item-ps").attr('data-pid');
		}
		
		// $('.pswp__info .title, .gallery-description__title').text(slickSlider.find(".slick-current").find('.slick-title').text());
		// $('.gallery-description-text').html(slickSlider.find(".slick-current").find('.slick-description').html());

		var gid = parseInt($(gallery).attr('data-gid')),
			items = self.items[gid],
			type = parseInt($(gallery).attr('data-thumb') ? $(gallery).attr('data-thumb') : 0),
			options = {
				showHideOpacity: true,
				galleryUID: gid,
				history: false,
				index: parseInt(startIndex),
				closeOnScroll: false,
				captionEl: false,
				fullscreenEl: true,
				barsSize: {top:30, bottom:30},
				getThumbBoundsFn: function(index) {
					var	pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
					thumbnail = self.items[gid][index].el;
					if (thumbnail) {
						var rect = thumbnail.getBoundingClientRect(),
						rectLeft = parseInt(rect.left.toFixed(1)),
						rectTop = parseInt(rect.top.toFixed(1)),
						rectWidth = parseInt(rect.width.toFixed(1));

						return {x:rectLeft, y:rectTop + pageYScroll, w:rectWidth};
					}
					else
						return false;
				},
				getDoubleTapZoom: function(isMouseClick, item) {
				    // if(!isMouseClick) {
				        return item.initialZoomLevel < 0.7 ? 1 : 1.5;
				    // }
				}
			};
		
		var galleryElement = $(gallery);
		gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();

		indexPs = gallery.getCurrentIndex();

		// if (isVideo) {
		// 	var currentIframe = $('iframe.pswp__video[data-index="'+indexPs+'"]');
		// 	currentIframe.css('display', 'block');
		// 	currentIframe.parent().siblings('.play-button-wrapper').find('span.play').css('display', 'none');
		// 	currentIframeSrc = currentIframe.attr('src');
		// 	if ($('html').hasClass('no-touch')) {
		// 		currentIframe.attr('src', currentIframeSrc+'?autoplay=1');
		// 	}
		// }

		// var titleSlide = $(galleryElement).find("[data-slick-index='"+indexPs+"']").find('.slick-title').text();
		// var textSlide = galleryElement.find("[data-slick-index='"+indexPs+"']").find('.slick-description').html();
		var textSlide = gallery.items[indexPs].description;

		// if (textSlide.length > 200 || textSlide.includes('<br')) {
		if (textSlide.length == 0) {
			$('.pswp__info .title, .gallery-description__title').text('');
			$('.gallery-description-text').html(textSlide);
			$('.info-icon').addClass('-visible');
		} else {
			$('.pswp__info .title, .gallery-description__title').text(textSlide);
			$('.gallery-description-text').html('');
			$('.info-icon').removeClass('-visible');
		}

		var topGap = 50;
		var bottomGap = topGap;
		var leftGap = 50;
		var rightGap = 50;

		gallery.options.barsSize.top = topGap;
		gallery.options.barsSize.bottom = bottomGap;
		gallery.options.barsSize.left = leftGap;
		gallery.options.barsSize.right = rightGap;
		gallery.updateSize(true);
		
		gallery.listen('beforeChange', function() {
			newIndexPs = gallery.getCurrentIndex();
			indexPs = newIndexPs;
			$('.pswp__video').each(function() {
				var src = $(this).attr('src');
				$(this).css('display', 'none');
				if (src && src.match(/\?autoplay=1/g)) {
					var repl = src.replace(/\?autoplay=1/, '');
					$(this).attr('src', repl);
				}
			});
			$('span.play').css('display', 'block');
			
			$('.pswp__info .title, .gallery-description__title').html(gallery.items[newIndexPs].description);
			$('.gallery-description').removeClass('-visible');
			$('body').removeClass('-gallery-description');
			// $('.pswp__info .title, .gallery-description__title').text(slickSlider.find(".slick-slide[data-slick-index='"+newIndexPs+"']").find('.slick-title').text());
			
		});

		gallery.listen('parseVerticalMargin', function(item) {
			var gap = item.vGap;
			gap.top = topGap;
			gap.bottom = bottomGap;
			gap.left = leftGap;
			gap.right = rightGap;
		});

		gallery.listen('afterChange', function() {
			var textSlide = gallery.items[indexPs].description;
			// if (textSlide.length > 200 || textSlide.includes('<br')) {
			if (textSlide.length == 0) {
				$('.pswp__info .title, .gallery-description__title').text('');
				$('.gallery-description-text').html(textSlide);
				$('.info-icon').addClass('-visible');
			} else {
				$('.pswp__info .title, .gallery-description__title').text(textSlide);
				$('.gallery-description-text').html('');
				$('.info-icon').removeClass('-visible');
			}

			// slickSlider.slick('slickGoTo', newIndexPs);
		});

		gallery.listen('gettingData', function(index, item) {
			//nothing here
		});
	
		gallery.listen('resize', function() {
			// $('.pswp__video').each(function() {
			// 	var img = $(this).parent('.iframe-wrapper').siblings('.pswp__imag');
			// 	var imgWidth = img.width();
			// 	var imgHeight = img.height();
			// 	$(this).css('width', imgWidth);
			// 	$(this).css('height', imgHeight);
			// });
		});

		gallery.listen('unbindEvents', function() { 
			// slickSlider.slick('slickGoTo', indexPs);
			setTimeout(function() {
				if ($('.pswp--open').length)
					$('.pswp--open').removeClass().addClass('pswp');
			}, 500);
		});

		$('.pswp .info-icon span').on('click touchstart', function(){
			$('.gallery-description').removeClass('-hidden');
			$('body').addClass('-gallery-description');
			$('body').scrollTop(0);
			setTimeout(function() {
				$('.gallery-description').addClass('-visible');
			}, 10);			
		});

		$('.gallery-description__close').on('click touchstart', function(){
			$('.gallery-description').removeClass('-visible');
			$('body').removeClass('-gallery-description');
			setTimeout(function() {
				$('.gallery-description').addClass('-hidden');
			}, 500);
		});

		if(fromURL) {
           	if(gallery.options.galleryPIDs) {
           	    // parse real index when custom PIDs are used 
           	    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
           	    for(var j = 0; j < items.length; j++) {
           	        if(items[j].pid == index) {
           	            gallery.options.index = j;
           	            break;
           	        }
           	    }
           	} else {
           	    // in URL indexes start from 1
           	    gallery.options.index = parseInt(index, 10) - 1;
           	}
       	} else {
			options.index = parseInt(index, 10);
		}

	    if( isNaN(options.index) ) {
			return;
		} 
	};

	var galleryElements = document.querySelectorAll(gallerySelector);
	// loop through all gallery elements and bind events

	for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

	var hashData = photoswipeParseHash();

	if(hashData.pid !== undefined && hashData.gid !== undefined) {
		openPhotoSwipe(galleryElements[hashData.gid], hashData.pid);
    }

    $('a.item-ps-trigger').click(function(e) {
    	e.preventDefault();
    	var galleryElements = document.querySelectorAll(gallerySelector);
		var pid = $(this).attr('data-index'),
			gid = $(this).closest(gallerySelector).attr('data-gid');
		openPhotoSwipe(galleryElements[gid], pid, null, null, true);
	});

  //   $('body').on('click touchstart','.play', function() {
		// var iframe = $(this).parent().siblings().find('iframe');
		// var src = iframe.attr('src');
		// iframe.css('display', 'block');
		// if ($('html').hasClass('no-touch')) {
		// 	iframe.attr('src', src+'?autoplay=1');
		// }
		// $(this).css('display', 'none');

		// $('.pswp__video').each(function() {
		// 	var img = $(this).parent('.iframe-wrapper').siblings('.pswp__imag');
		// 	var imgWidth = img.width();
		// 	var imgHeight = img.height();
		// 	$(this).css('width', imgWidth);
		// 	$(this).css('height', imgHeight);
		// });
  //   });

    // $('body').on('click touchstart', '.pswp__button--close', function() {
    	// $('.pswp__video').remove();
    // });

    $('body').on('click','a.item-ps',function(e) {
		e.preventDefault();
		// var isVideo;
		// var index = $(this).attr('data-pid');
		// var gallery = $(this).closest('.gallery-ps');
		// if ($(this).find('img').attr('data-ytlink') !== "" || $(this).find('img').attr('data-vimeolink') !== "") {
		// 	isVideo = true;
		// } else {
		// 	isVideo = false;
		// }
		// openPhotoSwipe(e.target, isVideo, index, gallery);
		// openPhotoSwipe(e.target, index, gallery);
		// setTimeout(function() {
		// 	$('.pswp__video').each(function() {
		// 		var img = $(this).parent('.iframe-wrapper').siblings('.pswp__imag');
		// 		var imgWidth = img.width();
		// 		var imgHeight = img.height();
		// 		$(this).css('width', imgWidth);
		// 		$(this).css('height', imgHeight);
		// 	});
		// }, 200);
	});

};

initPhotoSwipe.prototype.update = function() {
	this.getItems();
};
